/**
 * <license header>
 */

import ImsToken from '../../../framework/ims-token';
import { Connection } from '../types';
import CustomLogger from '../../../framework/custom-logger';

class ImsConnection implements Connection {
  private clientId: string;
  private clientSecret: string;
  private technicalAccountId: string;
  private technicalAccountEmail: string;
  private imsOrgId: string;
  private scopes: Array<string>;
  private customLogger: CustomLogger;

  /**
   * @param clientId
   * @param clientSecret
   * @param technicalAccountId
   * @param technicalAccountEmail
   * @param imsOrgId
   * @param scopes
   * @param logger
   */
  constructor(
    clientId: string,
    clientSecret: string,
    technicalAccountId: string,
    technicalAccountEmail: string,
    imsOrgId: string,
    scopes: Array<string>,
    logger: any = null
  ) {
    this.clientId = clientId;
    this.clientSecret = clientSecret;
    this.technicalAccountId = technicalAccountId;
    this.technicalAccountEmail = technicalAccountEmail;
    this.imsOrgId = imsOrgId;
    this.scopes = scopes;
    this.customLogger = new CustomLogger(logger);
  }

  /**
   * @param commerceGot
   */
  async extend(commerceGot: any): Promise<any> {
    this.customLogger.info('Using Commerce client with IMS authentication');

    const tokenGenerator = new ImsToken(
      this.clientId,
      this.clientSecret,
      this.technicalAccountId,
      this.technicalAccountEmail,
      this.imsOrgId,
      this.scopes,
      this.customLogger.getLogger(),
      'adobe_commerce_ims_token', // Use specific cache key for commerce client
      'adobe-commerce-client' // Use adobe-commerce-client context for backward compatibility
    );

    const token = await tokenGenerator.execute();

    if (token === null) {
      throw new Error('Failed to generate or retrieve IMS token');
    }

    this.customLogger.info(`IMS token being extended to header: ${token.substring(0, 10)}...`);

    return commerceGot.extend({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}

export default ImsConnection;
